<template>
    <div>
        <Header :isLight="isLight" :isMenuLight="isMenuLight"></Header>
        <div class="container">
            <h2 class="page-title">{{title}}</h2>
            <div class="back-list">
                <span @click="handleBack">返回列表
                    <span class="caret"></span>
                </span>
            </div>
            <!-- <p class="brief" v-if="subtitle">
                {{subtitle}}
            </p> -->
            <p class="time">{{formatTime(time)}}</p>
            <div class="news-content" v-html="content">
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Bottom from '@/components/Bottom'
import dataStatistics from '@/assets/js/dataStatistics'
import api from '@/api/api'
export default {
    name: 'detail',
    components: {
        Header,
        Bottom
    },
    data() {
        return {
            type: '',
            isLight: false,
            isMenuLight: false,
            content: '',
            title: '',
            time: '',
            subtitle: '',
            keepAliveList: ['news', 'riskmanage', 'notice', 'rules', 'industry']
        }
    },
    created() {
        this.articleType = Number(this.$route.query.from)
        const id = this.$route.query.id
        this.getArticleDetail(id)
        this.dataStatisticsType()
    },
    beforeRouteLeave(to, from, next) {
        const name = to.name.toLowerCase()
        if (this.keepAliveList.indexOf(name) === -1) {
            this.$store.commit('changeIncludes', [])
        }
        next()
    },
    methods: {
        dataStatisticsType() {
            const type = this.articleType
            if (type === 2) {
                dataStatistics('PC-新闻动态详情页', '进入', '文章浏览')
            } else if (type === 3) {
                dataStatistics('PC-公告通知详情页', '进入', '文章浏览')
            } else if (type === 4) {
                dataStatistics('PC-规章制度详情页', '进入', '文章浏览')
            } else if (type === 5) {
                dataStatistics('PC-行业共治详情页', '进入', '文章浏览')
            } else if (type === 6) {
                dataStatistics('PC-风控TV详情页', '进入', '文章浏览')
            }
        },
        handleBack() {
            switch (this.articleType) {
                case 2:
                    this.$router.push('news')
                    break;
                case 3:
                    this.$router.push('notice')
                    break;
                case 4:
                    this.$router.push('rules')
                    break;
                case 5:
                    this.$router.push('industry')
                    break;
                case 6:
                    this.$router.push('riskManage')
                    break;
                default:
                    break;
            }
        },
        getArticleDetail(id) {
            const params = { id }
            api.article.articleDetail(params).then(res => {
                if (res.data.code === 200) {
                    this.content = res.data.data.content
                    this.title = res.data.data.title
                    this.time = res.data.data.publishTime
                    this.subtitle = res.data.data.subtitle
                } else if (res.data.code === 400) {

                    this.$Message.error('文章已删除！')
                }
            })
        },
        formatTime(time) {
            return time ? this.$moment(time).format('YYYY/MM/DD') : time
        }
    }
}
</script>
<style lang="less" scoped>
.page-title {
  font-family: PingFangSC-Regular;
  font-size: 0.38rem;
  font-weight: normal;
  color: #000000;
  text-align: center;
  //   margin-top: 30px;
  margin-bottom: 20px;
  word-break: break-all;
}
.container {
  width: 70%;
  margin: 0 auto;
  padding-bottom: 50px;
  padding-top: 100px;
}
.back-list {
  text-align: right;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #000000;
  letter-spacing: 2px;
  span {
    cursor: pointer;
  }
}
.caret {
  transform: rotate(-90deg);
}
.time {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #999999;
  line-height: 30px;
  margin-top: 20px;
  margin-bottom: 40px;
}
.brief {
  font-family: PingFangSC-Regular;
  font-size: 0.24rem;
  color: #333333;
  line-height: 35px;
  margin-top: 32px;
}
.news-content {
  margin: 10px 0 50px;
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #000;
  letter-spacing: 0;
  line-height: 30px;
  word-break: break-all;
  min-height: 400px;
  /deep/ p{
      >iframe{
         width:640px;
         height:498px; 
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ArticleDetail.vue